module.exports = "<app-navigation></app-navigation>\n"